<template>
  <div :class="bem()" style="padding-top: 8px;">
    <v-btn flat icon @click.prevent="clear">
      <v-icon>clear</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { Clear } from 'vue-instantsearch'
import { mapMutations } from 'vuex'

export default {
  name: 'ais-clear',
  extends: Clear,
  data () {
    return {
      blockClassName: 'ais-clear'
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations(['setGlobalSearch']),
    ...mapMutations('searchEnginePage', ['setCheckedPools']),
    clear () {
      this.searchStore.stop()
      if (this.clearsQuery && this.searchStore.query.length > 0) {
        this.searchStore.query = ''
        this.setGlobalSearch('')

      }
      if (this.clearsFacets && this.searchStore.activeRefinements.length > 0) {
        this.searchStore.clearRefinements()
      }
      // Clear bookmarks
      this.setCheckedPools({})

      this.searchStore.start()
      this.searchStore.refresh()
    }
  }
}
</script>
